<template>
    <v-main>
        <router-view />
    </v-main>
</template>

<script>
export default {
    name: 'core-view',
};
</script>

<style>
</style>
